module.exports = __webpack_public_path__ + "img/icon@2x(7).29b45ce3.png";